(function () {
  'use strict';
  if (window.ByteRescueCaptcha) return;
  var loading = null;
  function bounded(promise) {
    return new Promise(function (resolve, reject) {
      var timer = setTimeout(function () { reject(new Error('Verification timed out.')); }, 12000);
      Promise.resolve(promise).then(function (result) { clearTimeout(timer); resolve(result); }, function (error) { clearTimeout(timer); reject(error); });
    });
  }
  function ready(api) { return new Promise(function (resolve) { api.ready(function () { resolve(api); }); }); }
  function load(siteKey) {
    if (!siteKey) return Promise.reject(new Error('Verification is not configured.'));
    if (window.grecaptcha && typeof window.grecaptcha.ready === 'function') return bounded(ready(window.grecaptcha));
    if (loading) return loading;
    var script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js?render=' + encodeURIComponent(siteKey);
    script.async = true; script.defer = true;
    loading = bounded(new Promise(function (resolve, reject) {
      script.onload = function () {
        if (!window.grecaptcha || typeof window.grecaptcha.ready !== 'function') return reject(new Error('Verification did not load.'));
        ready(window.grecaptcha).then(resolve, reject);
      };
      script.onerror = function () { reject(new Error('Verification could not load.')); };
      document.head.appendChild(script);
    })).catch(function (error) { script.remove(); loading = null; throw error; });
    return loading;
  }
  function initialize(scope) {
    var selector = '[data-request-form], [data-business-request-form]';
    var forms = Array.prototype.slice.call(scope.querySelectorAll(selector));
    if (scope.matches && scope.matches(selector)) forms.unshift(scope);
    forms.forEach(function (form) {
      if (!form.hasAttribute('data-form-started-at')) form.setAttribute('data-form-started-at', String(Date.now()));
      var key = form.getAttribute('data-recaptcha-site-key');
      if (!key || form.getAttribute('data-recaptcha-prewarm-bound') === 'true') return;
      form.setAttribute('data-recaptcha-prewarm-bound', 'true');
      var prewarm = function () {
        form.removeEventListener('focusin', prewarm); form.removeEventListener('pointerdown', prewarm);
        load(key).catch(function () {});
      };
      form.addEventListener('focusin', prewarm, { once: true });
      form.addEventListener('pointerdown', prewarm, { once: true, passive: true });
    });
  }
  function token(form) {
    var key = form.getAttribute('data-recaptcha-site-key');
    return load(key).then(function (api) { return bounded(api.execute(key, { action: 'submit_request' })); }).then(function (value) {
      if (!value) throw new Error('Verification did not complete.');
      return value;
    });
  }
  window.ByteRescueCaptcha = Object.freeze({ initialize: initialize, token: token });
})();
